import { AXIOS_ERROR_TIMEOUT_ECONNABORTED, AXIOS_ERROR_TIMEOUT_ETIMEDOUT } from '../constants';

export const isAxiosTimeoutError = (err: Error) => {
  const { code } = err as Record<string, any>;
  if ([AXIOS_ERROR_TIMEOUT_ETIMEDOUT, AXIOS_ERROR_TIMEOUT_ECONNABORTED].indexOf(code) !== -1) {
    return true;
  }

  return false;
};
